// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ToolSelectionParent {\n  background: transparent;\n  position: absolute;\n  right: 0px;\n  bottom: 0px;\n  pointer-events: none;\n  margin: 16px; }\n", ""]);
// Exports
module.exports = exports;
